import { CurrencyRateInterface, OffersInterface } from './interfaces';
import { CryptoCurrencyTypes, OfferTypes } from '../../../constants';

export const offerInitialState: OffersInterface = {
  publishedOffers: [],
  unpublishedOffers: [],
  draftOffers: [],
  filters: { offerType: OfferTypes.Buy, cryptoCurrency: CryptoCurrencyTypes.BTC, currencyCode: '' },
  currencyRate: {} as CurrencyRateInterface,
  isLoadingMore: false,
  currentPage: 1,
  hasMore: true,
};
